import { Component, Input } from '@angular/core';
import { ISalesInformation } from 'libraries/service/resources/model/search/IBooking';
import { faInfoCircle, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'sales-information',
    template: `
    <em *ngIf="salesInformation">
        <fa-icon [icon]="iconInfo"></fa-icon>
        {{ salesInformation.text}}
    </em>`,
    styles: [`

    em{
        display: flex;
    }

    .fa-info-circle {
        margin-right: 7px;
    }

    `],
})
export class SalesInformationComponent {
    @Input()
    public salesInformation: ISalesInformation;

    public iconInfo: IconDefinition = faInfoCircle;

    public iconClasses: string[] = ['fa-info-circle'];
}
